import React from 'react';
import './PlacesPage.css'; // Import the CSS file
import Navbar from './navbar/Navbar';
import Footer from './footer/Footer';
import PlacesSwiper from './sliders/PlacesSwiper';
import PlacesIntroduction from './sliders/PlacesIntroduction';



const PlacesPage = () => {
  return (
    <div>
    <div className="places-page">
        <Navbar />
        <PlacesIntroduction/>
        <PlacesSwiper/>
    </div>
    <Footer />
    </div>
);
};

export default PlacesPage;
